import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function PromptDialog({ open, onOpenChange, title, label, initial = "", confirmText = "Save", onSubmit, testId }) {
  const [value, setValue] = useState(initial);

  useEffect(() => {
    if (open) setValue(initial);
  }, [open, initial]);

  const submit = (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    onSubmit(value.trim());
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">{title}</DialogTitle>
          <DialogDescription className="sr-only">{title}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label className="text-slate-600">{label}</Label>
            <Input
              autoFocus
              data-testid={testId ? `${testId}-input` : "prompt-input"}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={label}
              className="focus-visible:ring-[#003366]"
            />
          </div>
          <DialogFooter>
            <Button
              type="submit"
              data-testid={testId ? `${testId}-submit` : "prompt-submit"}
              className="rounded-full bg-[#003366] hover:bg-[#00284d] text-white"
            >
              {confirmText}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function CardDialog({ open, onOpenChange, title, initialFront = "", initialBack = "", confirmText = "Save", onSubmit }) {
  const [front, setFront] = useState(initialFront);
  const [back, setBack] = useState(initialBack);

  useEffect(() => {
    if (open) {
      setFront(initialFront);
      setBack(initialBack);
    }
  }, [open, initialFront, initialBack]);

  const submit = (e) => {
    e.preventDefault();
    if (!front.trim() || !back.trim()) return;
    onSubmit({ front: front.trim(), back: back.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg bg-white">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">{title}</DialogTitle>
          <DialogDescription className="sr-only">{title}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label className="text-slate-600">Front</Label>
            <Textarea
              autoFocus
              data-testid="card-front-input"
              value={front}
              onChange={(e) => setFront(e.target.value)}
              placeholder="Question / prompt"
              className="min-h-[90px] focus-visible:ring-[#003366]"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-600">Back</Label>
            <Textarea
              data-testid="card-back-input"
              value={back}
              onChange={(e) => setBack(e.target.value)}
              placeholder="Answer"
              className="min-h-[90px] focus-visible:ring-[#003366]"
            />
          </div>
          <DialogFooter>
            <Button
              type="submit"
              data-testid="card-submit"
              className="rounded-full bg-[#003366] hover:bg-[#00284d] text-white"
            >
              {confirmText}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
